import { Component, HostListener } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column (click)="onLayoutContainerClick($event)">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {
  constructor(private sidebarService: NbSidebarService) {
  }
  // 判断是否是移动端
  isMobile(): boolean {
    return window.innerWidth < 768;
  }

  onLayoutContainerClick(event: MouseEvent) {
    const layoutContainer = document.querySelector('.layout-container');
    if (!layoutContainer) return;

    const sidebar = document.querySelector('nb-sidebar[responsive][tag="menu-sidebar"]');
    const isCollapsed = sidebar?.classList.contains('collapsed') ?? false;

    if (!isCollapsed && this.isMobile()) {
      this.sidebarService.toggle(false, 'menu-sidebar');
    }

  }
}